
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { ArrowRight, Clock } from "lucide-react";
import { useState, useEffect } from "react";
import { CurrentRound } from "@/types";
import { toast } from "sonner";

const ActionButtons = () => {
  const navigate = useNavigate();
  const [activeRound, setActiveRound] = useState<CurrentRound | null>(null);

  // Check localStorage for any active rounds on component mount
  useEffect(() => {
    const storedRound = localStorage.getItem('activeRound');
    if (storedRound) {
      try {
        const parsedRound = JSON.parse(storedRound) as CurrentRound;
        // Validate that the required fields exist
        if (parsedRound.golfers && parsedRound.courseId && parsedRound.date) {
          const roundDate = new Date(parsedRound.date).toDateString();
          const today = new Date().toDateString();
          if (roundDate !== today) {
            localStorage.removeItem('activeRound');
          } else {
            setActiveRound(parsedRound);
          }
        }
      } catch (e) {
        console.error("Error parsing stored round:", e);
        localStorage.removeItem('activeRound');
      }
    }
  }, []);

  const handleScoreGroup = () => {
    localStorage.removeItem('activeRound');
    navigate("/scoring");
  };

  const handleResumeGroup = () => {
    if (activeRound) {
      navigate("/scoring");
      toast.success("Resumed scoring", {
        description: "Continuing your scoring session",
      });
    }
  };

  return (
    <div className="px-4 mb-6">
      <Button
        className="w-full bg-forest hover:bg-forest/90 text-white flex items-center justify-center gap-3 py-7
                   shadow-sm rounded-xl transition-colors"
        onClick={handleScoreGroup}
      >
        <span className="text-lg font-medium tracking-wide">Let's Play</span>
        <ArrowRight className="h-5 w-5" />
      </Button>

      {activeRound && (
        <Button
          variant="outline"
          className="w-full mt-3 bg-gold/10 border-gold/30 text-forest hover:bg-gold/20 flex items-center justify-center gap-2 py-5 rounded-xl transition-colors"
          onClick={handleResumeGroup}
        >
          <Clock className="h-4 w-4" />
          <span className="font-medium">Resume Round</span>
        </Button>
      )}
    </div>
  );
};

export default ActionButtons;
